import {ApplicationStatus} from '@app/views/admin/application-settings/models/application-status.model';
import {Application} from '@app/views/admin/application-settings/models/application.model';
import {ApplicationProviderListModel} from '@app/views/admin/application-settings/models/application-provider-list.model';
import {ProcessConfig} from '@app/views/admin/application-settings/models/process-config.model';

export class ADAWApplication extends Application {
    public id: string;
    public name: string;
    public description: string;
    public logoUrl: string;
    public topologyImageUrl: string;
    public status: ApplicationStatus;
    public parameters: ADAWParameter[];

    constructor() {
        super();
    }
}

export class ADAWParameter {
    constructor(
        public name: string = '',
        public value: string = '',
        public type: string = ''
    ) {
    }
}

export class ADAWIntegration extends ApplicationProviderListModel{
    id: string; // ToDo: missed in backend
    status: ApplicationStatus;
    districtId: string;
    lastRun: ADAWIntegrationLastRun;
    parameters: ADAWParameter[];
    schedules: ADAWSchedule[];
    processConfigModel: ProcessConfig[];

    description: string; // ToDo: added in backend
    logoUrl: string; // ToDo: added in backend
    topologyImageUrl: string; // ToDo: added in backend
    nextSyncDateList: Date[];

    // integrationId: string; // ToDo: need to be set from applicationId or id

    constructor(
        public name: string = '',
        public guid: string = '',

        public applicationId: string = '',
        public syncMode: string = null,
        public icon: string,
        public lastExecutionDate: string,
        public lastExecutionStatus: number, // ToDo: If errors - how count it ???

        public isADAWApplication: boolean = true,
        public expirationTs: Date = null,
    ) {
        super(guid, name, expirationTs);
    }
}

export class ADAWIntegrationLastRun {
    constructor(
        public timestamp: string,
        public success: boolean
    ) {
    }
}

export class ADAWLogEvent {
    constructor(
        public id: string = '',
        public timestamp: string,
        public type: 'INFO' | 'ERROR' | 'SUCCESS',
        public message: string = ''
    ) {
    }
}

export class ADAWSchedule {
    constructor(
        public id: string = '',
        public cronExpression : string[]
    ) {
    }
}
